
namespace RioERP.Masters {
    export class WhatsAppTemplateVariablesColumns {
        static columnsKey = 'Masters.WhatsAppTemplateVariables';
    }
}